module.exports = __webpack_public_path__ + "img/store_not_found.954b6029.png";